import { ISmartGroup } from "../../engine/DataModels/ISmartPattern"
import biblio_200_220 from "../../assets/patterns/biblio-200-220-2.3.png";
import biblio_221_250 from "../../assets/patterns/biblio-221-250-2.3.png";

const GKEY = "2.3";
export const BiblioGroup2_3: ISmartGroup = {
    key: GKEY,
    modulesByInterval: [
        {
            groupKey: GKEY,
            itvalIdx: 0,
            icon: biblio_200_220,
            zones: [
            { Ac:3, SWD: [0,0] },
            { Ac:1.5 }, 
            { Ac:3, SWD: [0,0] },
            { Ac:1.5 }
        ]},
        {
            groupKey: GKEY,
            itvalIdx: 1,
            icon: biblio_221_250,
            zones: [
            { Ac:3, SWD: [0,0] },
            { Ac:1.5 }, 
            { Ac:3, SWD: [0,0] },
            { Ac:1.5 },
            { Ac:1 }
        ]}
    ]
}